const Geometry = {}

Geometry.roundToWholeNumber = function({x, y, z}) {
    return {
        "x": Math.floor(x),
        "y": Math.floor(y),
    }
}
Geometry.roundToHalfpoint = function({x, y, z}) {
    return {
        "x": Math.floor(x + 0.5) - 0.5,
        "y": Math.floor(y + 0.5) - 0.5,
    }
}
Geometry.roundToWholeOrHalf = function({x, y, z}) {
    return {
        "x": Math.floor(x * 2) / 2,
        "y": Math.floor(y * 2) / 2,
    }
}
Geometry.vector = function(a, b) {
    a = Geometry.default(a)
    b = Geometry.default(b)
    return {
        "x": Math.sign(a.x - b.x),
        "y": Math.sign(a.y - b.y),
        "z": Math.sign(a.z - b.z),
    }
}

Geometry.direction = function(a, b) {
    return Geometry.normalize(Geometry.vector(a, b))
}

Geometry.orthodistance = function(a, b) {
    a = Geometry.default(a)
    b = Geometry.default(b)
    return Math.abs(a.x - b.x) + Math.abs(a.y - b.y)
}

Geometry.distance = function(a, b) {
    a = Geometry.default(a)
    b = Geometry.default(b)
    let x = a.x - b.x
    let y = a.y - b.y
    return Math.sqrt(x * x + y * y)
}

Geometry.distanceFromEdgeBetweenTwoPoints = function(testPoint, a, b) {
    // First define the edge between points A and B
    const edgeOffsetFromBToA = Geometry.difference(a, b)
    const edgeUnitVectorFromBToA = Geometry.normalize(edgeOffsetFromBToA)

    // Then find the distance from the test point to one of the ends
    const testPointFromB = Geometry.difference(testPoint, b)
    // Then find the point along the edge closest to our testpoint
    let projectionDistance = Geometry.dotProduct(testPointFromB, edgeUnitVectorFromBToA)
    if(projectionDistance < 0) projectionDistance = 0
    if(projectionDistance > Geometry.distance(a, b)) projectionDistance = Geometry.distance(a, b)
    const testPointProjectionOntoEdge = Geometry.scalarMultiply(projectionDistance, edgeUnitVectorFromBToA)
    // And measure the distance from that closest point
    const testPointPerpendicularDistanceFromEdge = Geometry.distance(testPointFromB, testPointProjectionOntoEdge)

    return testPointPerpendicularDistanceFromEdge
}

Geometry.length = function(a) {
    return Math.sqrt(a.x * a.x + a.y * a.y)
}

Geometry.normalize = function(a) {
    const x = a.x / Geometry.length(a)
    const y = a.y / Geometry.length(a)
    return { "x": x, "y": y }
}

Geometry.multiply = function(a, b) {
    a = Geometry.default(a)
    b = Geometry.default(b)
    return {
        "x": a.x * b.x,
        "y": a.y * b.y,
        "z": a.z * b.z,
    }
}

Geometry.scalarMultiply = function(scale, a) {
    a = Geometry.default(a)
    return {
        "x": a.x * scale,
        "y": a.y * scale,
        "z": a.z * scale,
    }
}

Geometry.dotProduct = function(a, b) {
    a = Geometry.default(a)
    b = Geometry.default(b)
    return a.x * b.x + a.y * b.y + a.z * b.z
}

Geometry.add = function() {
    return Array.from(arguments).reduce((a, b) => {
        b = Geometry.default(b)
        return {
            "x": a.x + b.x,
            "y": a.y + b.y,
            "z": a.z + b.z,
        }
    }, {
        "x": 0, "y": 0, "z": 0,
    })
}

Geometry.difference = function(a, b) {
    a = Geometry.default(a)
    b = Geometry.default(b)
    return {
        "x": a.x - b.x,
        "y": a.y - b.y,
        "z": a.z - b.z,
    }
}

Geometry.unit = function(p) {
    return {
        "x": p.x == 0 ? 0 : 1,
        "y": p.y == 0 ? 0 : 1,
    }
}

Geometry.perpendicular = function(p) {
    return {
        "x": p.x == 0 ? 1 : 0,
        "y": p.y == 0 ? 1 : 0,
        // "z": // ??
    }
}

Geometry.flip = function(p) {
    return Geometry.multiply(p, {"x": -1, "y": -1})
}

Geometry.rotate = function(p, degrees) {
    const radians = degrees * (Math.PI / 180)
    return {
        "x": (p.x * Math.cos(radians)) - (p.y * Math.sin(radians)),
        "y": (p.x * Math.sin(radians)) + (p.y * Math.cos(radians)),
        "z": p.z,
    }
}

Geometry.default = function(p) {
    if(p == undefined) {
        return {"x": 0, "y": 0, "z": 0}
    }
    if(isNaN(p) == false) {
        return {
            "x": p,
            "y": p,
            "z": p,
        }
    }
    return {
        "x": p.x || 0,
        "y": p.y || 0,
        "z": p.z || 0,
    }
}

// Geometry.toString()
// @returns: a string representation of the point.
// @example:
// > const point = {"x": 5, "y": 3, "z": 1}
// > assert(Geometry.toString(point) === "5x3x1")
Geometry.toString = function(point) {
    return point.x + "x" + point.y + "x" + point.z
}

Geometry.getNeighborPoints = function(point, range) {
    if(Number.isInteger(range)) {
        range = {"min": range, "max": range, "orthogonal": true, "diagonal": range >= 2}
    }
    if(range == undefined) {
        range = {"min": 1, "max": 1, "orthogonal": true, "diagonal": false}
    }
    let points = []
    if(range.directions != undefined) {
        range.directions.forEach((direction) => {
            for(let i = range.min; i <= range.max; i += 1) {
                points.push({
                    "x": point.x + ((direction.x || 0) * i),
                    "y": point.y + ((direction.y || 0) * i),
                    "z": point.z,
                    "order": direction.order
                })
            }
        })
    }
    if(range.orthogonal == true) {
        for(let i = range.min; i <= range.max; i += 1) {
            points.push({"x": point.x + i, "y": point.y, "z": point.z})
            points.push({"x": point.x - i, "y": point.y, "z": point.z})
            points.push({"x": point.x, "y": point.y + i, "z": point.z})
            points.push({"x": point.x, "y": point.y - i, "z": point.z})
        }
    }
    if(range.diagonal == true) {
        for(let i = range.min; i <= range.max; i += 1) {
            for(let j = 0; j < i; j += 1) {
                // if(i == 0) continue
                const x = j
                const y = i - j

                points.push({"x": point.x + x, "y": point.y + y, "z": point.z})
                points.push({"x": point.x - x, "y": point.y + y, "z": point.z})
                points.push({"x": point.x + x, "y": point.y - y, "z": point.z})
                points.push({"x": point.x - x, "y": point.y - y, "z": point.z})
            }
        }
    }
    return points
}

Geometry.directions = {
    "north": {"x": 0, "y": -1},
    "south": {"x": 0, "y": +1},
    "east": {"x": +1, "y": 0},
    "west": {"x": -1, "y": 0},
    "southeast": {"x": +1, "y": +1},
    "northeast": {"x": +1, "y": -1},
    "southwest": {"x": -1, "y": +1},
    "northwest": {"x": -1, "y": -1},
}

Geometry.orthodirections = {
    "north": {"x": 0, "y": -1},
    "south": {"x": 0, "y": +1},
    "east": {"x": +1, "y": 0},
    "west": {"x": -1, "y": 0},
}

Geometry.name = function(direction) {
    return Object.keys(Geometry.directions).find((directionKey) => {
        return Geometry.directions[directionKey].x == direction.x
            && Geometry.directions[directionKey].y == direction.y
    })
}

Geometry.isWithinRange = function(a, b, range) {
    const distance = Geometry.distance(a, b)
    if(Number.isInteger(range)) {
        return distance <= range && distance > range - 1
    }
    if(range == undefined) {
        return false
    }
    const vector = Geometry.difference(a, b)
    vector.x = Math.abs(vector.x)
    vector.y = Math.abs(vector.y)
    if(range.orthogonal == true) {
        if(vector.x <= range.max && vector.x >= range.min && vector.y == 0) return true
        if(vector.y <= range.max && vector.y >= range.min && vector.x == 0) return true
    }
    const diagonal = vector.x + vector.y
    if(range.diagonal == true) {
        if(diagonal >= range.max
        && diagonal >= range.min) {
            return true
        }
    }
    return false
}

Geometry.equals = function(a = {}, b = {}) {
    return (a.x || 0) == (b.x || 0)
        && (a.y || 0) == (b.y || 0)
        && (a.z || 0) == (b.z || 0)
}

Geometry.equals2d = function(a = {}, b = {}) {
    return a.x == b.x
        && a.y == b.y
}

Geometry.copy = function(point) {
    return {
        "x": point.x,
        "y": point.y,
        "z": point.z,
    }
}

Geometry.zero = function() {
    return {
        "x": 0,
        "y": 0,
        "z": 0,
    }
}

Geometry.isBounded = function(bounds, point) {
    return bounds != undefined
        && point != undefined
        && bounds.x1 <= point.x
        && bounds.x2 >= point.x
        && bounds.y1 <= point.y
        && bounds.y2 >= point.y
}

Geometry.area = function(points) {
    let area = 0
    for (var i = 0; i < points.length; i++) {
        const j = (i + 1) % points.length
        area += points[i].x * points[j].y
        area -= points[j].x * points[i].y
    }
    return area / 2
}

export default Geometry
